/* AGC CardShop – Makeover v2: Animationen & Interaktionen (ohne Abhängigkeiten) */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  ready(function () {
    /* Hero-Überschrift Wort für Wort */
    $all('[data-agc-words]').forEach(function (el) {
      var i = 0;
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
              var s = document.createElement('span');
              s.className = 'agc-word'; s.style.setProperty('--w', i++); s.textContent = part;
              frag.appendChild(s);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1) { walk(n); }
        });
      })(el);
    });
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('agc-ready'); }); });

    /* Ankündigungsleiste: rotierende Nachrichten (Handy/Tablet) */
    $all('.agc-announce').forEach(function (bar) {
      var items = $all('.agc-announce__item', bar);
      if (items.length < 2) { if (items[0]) items[0].classList.add('is-active'); return; }
      var idx = 0; items[0].classList.add('is-active');
      if (reduce) return;
      setInterval(function () {
        if (window.innerWidth >= 900) return;
        var cur = items[idx]; idx = (idx + 1) % items.length; var next = items[idx];
        cur.classList.remove('is-active'); cur.classList.add('is-leaving');
        next.classList.remove('is-leaving'); next.classList.add('is-active');
        setTimeout(function () { cur.classList.remove('is-leaving'); }, 600);
      }, 3800);
    });

    /* Vertrauens-Leiste: für Endlos-Laufband duplizieren */
    $all('.agc-trust ul').forEach(function (ul) {
      $all('li', ul).forEach(function (li) { var c = li.cloneNode(true); c.setAttribute('aria-hidden', 'true'); ul.appendChild(c); });
    });

    /* Header-Glas beim Scrollen + Hero-Parallax */
    var heroBg = document.querySelector('.agc-hero__bg');
    var ticking = false;
    function onScroll() {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        root.classList.toggle('agc-scrolled', y > 12);
        if (heroBg && !reduce && y < 900) heroBg.style.transform = 'translate3d(0,' + (y * 0.25).toFixed(1) + 'px,0)';
        ticking = false;
      });
    }
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });

    /* Hero: Funken + Licht folgt der Maus */
    $all('.agc-hero').forEach(function (hero) {
      var box = hero.querySelector('.agc-hero__sparkles');
      if (box && !reduce) {
        var n = window.innerWidth < 640 ? 12 : 22;
        for (var k = 0; k < n; k++) {
          var s = document.createElement('span'); s.className = 'agc-spark';
          s.style.left = (Math.random() * 100).toFixed(1) + '%';
          s.style.top = (35 + Math.random() * 60).toFixed(1) + '%';
          s.style.setProperty('--d', (4 + Math.random() * 5).toFixed(1) + 's');
          s.style.setProperty('--delay', (-Math.random() * 8).toFixed(1) + 's');
          var size = (2 + Math.random() * 3).toFixed(1) + 'px'; s.style.width = size; s.style.height = size;
          box.appendChild(s);
        }
      }
      var glow = hero.querySelector('.agc-hero__glow');
      if (glow && finePointer && !reduce) {
        hero.addEventListener('pointermove', function (e) {
          var r = hero.getBoundingClientRect();
          glow.style.setProperty('--agc-gx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          glow.style.setProperty('--agc-gy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        });
      }
    });

    /* Scroll-Einblendungen */
    var targets = [];
    $all('main [data-agc-reveal-group]').forEach(function (group) {
      var mode = group.getAttribute('data-agc-reveal-group') || '';
      $all(':scope > *', group).forEach(function (child, i) {
        child.style.setProperty('--agc-i', Math.min(i, 8));
        if (mode) child.setAttribute('data-agc-reveal', mode); else child.setAttribute('data-agc-reveal', '');
        targets.push(child);
      });
    });
    $all('main [data-agc-reveal]').forEach(function (el) { if (targets.indexOf(el) === -1) targets.push(el); });
    /* Theme-eigene Raster (Kollektionen, Suche, ähnliche Produkte) ebenfalls animieren */
    $all('main .grid').forEach(function (g) {
      if (g.closest('[data-agc-reveal-group]') || g.closest('.agc-pdp')) return;
      $all(':scope > *', g).forEach(function (child, i) {
        if (child.hasAttribute('data-agc-reveal')) return;
        child.style.setProperty('--agc-i', i % 4); child.setAttribute('data-agc-reveal', ''); targets.push(child);
      });
    });

    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('agc-in');
          $all('.agc-pcard', e.target).forEach(function (c) { c.classList.add('agc-in'); });
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
      targets.forEach(function (el) { io.observe(el); });
    } else {
      targets.forEach(function (el) { el.classList.add('agc-in'); });
    }

    /* Ripple auf Buttons */
    document.addEventListener('pointerdown', function (e) {
      if (reduce) return;
      var btn = e.target.closest('.btn, .agc-btn');
      if (!btn || btn.disabled) return;
      var r = btn.getBoundingClientRect(); var d = Math.max(r.width, r.height);
      var rip = document.createElement('span'); rip.className = 'agc-ripple';
      rip.style.width = rip.style.height = d + 'px';
      rip.style.left = (e.clientX - r.left - d / 2) + 'px'; rip.style.top = (e.clientY - r.top - d / 2) + 'px';
      btn.appendChild(rip); setTimeout(function () { rip.remove(); }, 650);
    });

    /* "In den Warenkorb": Warenkorb-Symbol hüpft */
    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-quick-add], [data-sticky-atc-btn], form[action*="/cart/add"] [type="submit"]');
      if (!add || reduce) return;
      add.classList.remove('is-added'); void add.offsetWidth; add.classList.add('is-added');
      setTimeout(function () {
        $all('[data-cart-open]').forEach(function (c) { c.classList.remove('agc-bump'); void c.offsetWidth; c.classList.add('agc-bump'); });
      }, 350);
    });

    /* Holo-Tilt (nur Maus/Trackpad) */
    if (!finePointer || reduce) return;
    $all('.agc-pcard').forEach(function (card) {
      var frame = null;
      card.addEventListener('pointermove', function (ev) {
        var r = card.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width, y = (ev.clientY - r.top) / r.height;
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          card.classList.add('agc-tilting');
          card.style.setProperty('--agc-ry', ((x - 0.5) * 12).toFixed(2) + 'deg');
          card.style.setProperty('--agc-rx', ((0.5 - y) * 12).toFixed(2) + 'deg');
          card.style.setProperty('--agc-mx', (x * 100).toFixed(1) + '%');
          card.style.setProperty('--agc-my', (y * 100).toFixed(1) + '%');
        });
      });
      card.addEventListener('pointerleave', function () {
        if (frame) cancelAnimationFrame(frame);
        card.classList.remove('agc-tilting');
        card.style.setProperty('--agc-rx', '0deg'); card.style.setProperty('--agc-ry', '0deg');
      });
    });
  });
})();
